'use strict'

import SearchAutocomplete from '@ui/Search/Form/Fields/Autocomplete/component'
import dataLayer, { DataLayer } from 'assets/core/js/module/dataLayer'

import type { SearchAutocomplete as SearchAutocompleteType } from '@ui/Search/Form/Fields/Autocomplete/component'

export default function (): SearchAutocompleteType | void {
  const fieldEl = document.querySelector<HTMLElement>('#search-offers .search-form-autocomplete')

  if (!fieldEl) {
    return
  }

  const autocomplete = SearchAutocomplete(fieldEl, {
    callbackSearchSuggestionClick: (link: HTMLElement): void => {
      let data = null
      const rawData = link.getAttribute('data-datalayer-click')
      if (rawData !== null) {
        data = JSON.parse<DataLayer>(rawData)
      }
      if (data === null) {
        return
      }

      dataLayer.pushInLayer(window.coreGtmId, data)
    },
  })

  return autocomplete
}
